import React, { useState, useEffect } from "react";
import Accordion from "react-bootstrap/Accordion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FaSpinner } from "react-icons/fa";
import Select from "react-select";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ReactDatePicker from "react-datepicker";
import { API_URL } from "../../../../constants";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const EditLeaveForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [submitted, setSubmit] = useState(false);
  const [activeKey, setActiveKey] = useState("0");
  const [genderOptions, setGenderOptions] = useState([]);
  const [formData, setFormData] = useState({
    Code: "",
    Name: "",
    Value: 0,
    Description: "",
    DefaultDay: "",
    MaximumCarryForwardDays: "",
    IsHalfDayAllow: 0,
    IsAllowedInNoticePeriod: 0,
    IsEvidenceRequired: 0,
    IsInActive: 0,
    IsAccrual: 0,
    AccumulationPerMonth: "",
    LimitPerYear: "",
    lines: [
      {
        LeaveID: "",
        LineNo: 1,
        LeaveAccrualType_155: "",
        MinimumNo: "",
        MaximumNo: "",
        AllowLeaveNo: "",
        FromDate: "",
        ToDate: "",
      },
    ],
  });
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Edit Leave"));
  }, []);

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    });
  };

  const fetchOptions = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}leaves-list`);
      if (response.status === 200) {
        const titleoption = response.data.gender;

        const TitleOption = titleoption.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));

        TitleOption.unshift({ value: null, label: "Select.." });
        setGenderOptions(TitleOption);
      }
    } catch (error) {
      console.error("Error fetching job details:", error);
    }
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  const handleChange = (e, index) => {
    const { name, value } = e.target;
    const updatedLines = [...formData.lines];
    updatedLines[index][name] = value;
    setFormData((prevState) => ({
      ...prevState,
      lines: updatedLines,
    }));
  };

  const handleDateChange = (date, index, field) => {
    const updatedLines = [...formData.lines];
    updatedLines[index][field] = moment(date).format("DD-MM-YYYY");
    setFormData((prevState) => ({
      ...prevState,
      lines: updatedLines,
    }));
  };

  const handleAddLine = () => {
    const addLine = formData.lines[formData.lines.length - 1];

    if (
      !addLine ||
      !addLine.MinimumNo ||
      !addLine.MaximumNo ||
      !addLine.AllowLeaveNo ||
      !addLine.FromDate ||
      !addLine.ToDate
    ) {
      toast.error(
        "Please fill in all fields in the current row before adding a new one."
      );
      return;
    }

    const newLineNo = formData.lines.length + 1;
    const newLine = {
      LineNo: newLineNo,
      MinimumNo: "",
      MaximumNo: "",
      AllowLeaveNo: "",
      FromDate: "",
      ToDate: "",
      is_inactive: true,
    };

    setFormData((prevState) => ({
      ...prevState,
      lines: [...prevState.lines, newLine],
    }));
  };

  const handleDeleteLine = (index) => {
    const updatedLines = formData.lines.filter((_, i) => i !== index);
    setFormData((prevState) => ({
      ...prevState,
      lines: updatedLines,
    }));
  };
  const parseDate = (dateStr) => {
    return dateStr ? moment(dateStr, "DD-MM-YYYY").toDate() : null;
  };

  const fetchData = async (id) => {
    try {
      const response = await GetServiceCaller(API_URL + "leaves-list/" + id);

      if (response.status === 200) {
        const leaveData = response?.data?.leaves;
        const leaveLineData = response?.data?.leavesLine;
        const lines = leaveLineData.map((version) => ({
          LeaveID: id,
          LineNo: version.LineNo,
          LeaveAccrualType_155: version.LeaveAccrualType_155 || "",
          MinimumNo: version.MinimumNo || "",
          MaximumNo: version.MaximumNo || "",
          AllowLeaveNo: version.AllowLeaveNo || "",
          FromDate: version.FromDate || "",
          ToDate: version.ToDate || "",
        }));

        if (leaveData) {
          const {
            Name,
            Code,
            Description,
            DefaultDay,
            PriorIntimationPeriod,
            AccumulationPerMonth,
            LimitPerYear,
            IsAccrual,
            IsHalfDayAllow,
            IsAllowedInNoticePeriod,
            MaximumCarryForwardDays,
            IsEvidenceRequired,
            IsInActive,
          } = leaveData;
          setFormData((prevData) => ({
            ...prevData,
            Name: Name || "",
            Code: Code || "",
            Description: Description || "",
            DefaultDay: DefaultDay || "",
            PriorIntimationPeriod: PriorIntimationPeriod || "",
            AccumulationPerMonth: AccumulationPerMonth || "",
            LimitPerYear: LimitPerYear || "",
            IsAccrual: IsAccrual || "",
            MaximumCarryForwardDays: MaximumCarryForwardDays || "",
            IsHalfDayAllow: IsHalfDayAllow || "",
            IsAllowedInNoticePeriod: IsAllowedInNoticePeriod || "",
            IsEvidenceRequired: IsEvidenceRequired || "",
            IsInActive: IsInActive || "",
            lines: lines,
          }));
        } else {
          console.error("Leave data not found with ID:", id);
        }
      } else {
        console.error(
          "Failed to fetch leave details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching leave details:", error);
    }
  };
  useEffect(() => {
    if (id) {
      fetchData(id);
    }
  }, [id]);
  const validateForm = () => {
    const newErrors = {};
    if (!formData.Name) newErrors.Name = "Name is required";
    if (!formData.DefaultDay) newErrors.DefaultDay = "Days Allowed is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const response = await PostServiceCaller(
          `${API_URL}leaves-list/${id}`,
          formData,
          "put"
        );

        if (response.status === 200) {
          toast.success("Form Updated successfully!", {
            position: "top-right",
          });
          console.log("Response:", response.data);
          navigate("/leave-list");
        } else {
          toast.error("Unexpected response status: " + response.status, {
            position: "top-right",
          });
        }
      } catch (error) {
        toast.error("Error submitting form. Please try again.", {
          position: "top-right",
        });
        console.error("Error posting data:", error);
      }
    }
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <form onSubmit={handleEdit}>
            <div className="container-fluid">
              <Accordion activeKey={activeKey} onSelect={handleToggle}>
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="">
                    <div className="flex-grow-1 text-dark fw-bold">
                      General Details
                    </div>
                    <span className="me-2 accordion_icon">
                      <FontAwesomeIcon
                        icon={activeKey === "0" ? faMinus : faPlus}
                      />
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="row">
                      <div className="col-md-3">
                        <label className="form-label">Code</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Code"
                          id="Code"
                          aria-describedby="Code"
                          name="Code"
                          disabled
                          value={formData.Code}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Name<span className="error">*</span></label>
                        <input
                          type="text"
                          className={`form-control ${errors.Name ? "is-invalid" : ""
                            }`}
                          placeholder="Name"
                          id="Name"
                          aria-describedby="Name"
                          name="Name"
                          value={formData.Name}
                          onChange={handleInputChange}
                        />
                        {errors.Name && (
                          <div className="invalid-feedback">{errors.Name}</div>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Description</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Description"
                          id="Description"
                          aria-describedby="Description"
                          name="Description"
                          value={formData.Description}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Category</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Category"
                          required
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-2">
                        <label className="form-label">Gender</label>
                        <Select
                          options={genderOptions}
                          name="Title"
                          value={formData.Title}
                        // onChange={(e) => handleDropDownChange(e, "Title")}
                        />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Days Allowed<span className="error">*</span></label>
                        <input
                          type="text"
                          className={`form-control ${errors.DefaultDay ? "is-invalid" : ""
                            }`}
                          id="DefaultDay"
                          aria-describedby="DefaultDay"
                          name="DefaultDay"
                          value={formData.DefaultDay}
                          onChange={handleInputChange}
                        />
                        {errors.DefaultDay && (
                          <div className="invalid-feedback">
                            {errors.DefaultDay}
                          </div>
                        )}
                      </div>
                      <div className="col-md-2 mt-4">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="IsHalfDayAllow"
                            id="IsHalfDayAllow"
                            checked={formData.IsHalfDayAllow === 1}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="IsHalfDayAllow">
                            Allow Half Day Leave
                          </label>
                        </div>
                      </div>

                      <div className="col-md-3 mt-4">
                       
                        <div className="form-check ">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="IsAllowedInNoticePeriod"
                            id="flexSwitchCheckChecked"
                            checked={formData.IsAllowedInNoticePeriod === 1}
                            onChange={handleInputChange}
                          />
                           <label className="form-label">
                          {" "}
                          Allow Application in Notice Period
                        </label>
                        </div>
                      </div>
                      <div className="col-md-2 mt-4">
                      
                        <div className="form-check ">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="IsInActive"
                            id="flexSwitchCheckChecked"
                            checked={formData.IsInActive === 1}
                            onChange={handleInputChange}
                          />
                            <label className="form-label">Active</label>
                        </div>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>

                {/* item 2 */}
                <Accordion.Item eventKey="1">
                  <Accordion.Header className="">
                    <div className="flex-grow-1 text-dark fw-bold">
                      Additional Details
                    </div>
                    <span className="me-2 accordion_icon">
                      <FontAwesomeIcon
                        icon={activeKey === "1" ? faMinus : faPlus}
                      />
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="row">
                      <div className="col-md-3">
                        <label className="form-label">
                          Prior Intimation for Application (Days)
                        </label>
                        <input
                          type="text"
                          class="form-control text-end"
                          placeholder="In Days"
                          required
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">
                          Post Intimation for Application (Days)
                        </label>
                        <input
                          type="text"
                          class="form-control text-end"
                          placeholder="In Days"
                          required
                        />
                      </div>
                      <div className="col-md-2">
                        <label htmlFor="evidence" className="form-label">
                          {" "}
                          Evidence Required
                        </label>
                        <div>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="IsEvidenceRequired"
                            id="flexSwitchCheckChecked"
                            checked={formData.IsEvidenceRequired === 1}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">
                          Evidence Description
                        </label>
                        <input
                          type="text"
                          class="form-control text-end"
                          placeholder="In Days"
                          required
                        />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Evidence Exclusion</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="In Days"
                          required
                        />
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>

                {/* item 3 */}
                <Accordion.Item eventKey="2">
                  <Accordion.Header className="">
                    <div className="flex-grow-1 text-dark fw-bold">
                      Accrual Leave Details
                    </div>
                    <span className="me-2 accordion_icon">
                      <FontAwesomeIcon
                        icon={activeKey === "2" ? faMinus : faPlus}
                      />
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="row">
                      <div className="col-md-3">
                        <label className="form-label">
                          Maximum Encashed Days
                        </label>
                        <input
                          type="text"
                          class="form-control text-end"
                          placeholder="In Days"
                          required
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">
                          Maximum Carry Forward Days
                        </label>
                        <input
                          type="text"
                          class="form-control text-end"
                          placeholder="In Days"
                          id="MaximumCarryForwardDays"
                          aria-describedby="MaximumCarryForwardDays"
                          name="MaximumCarryForwardDays"
                          value={formData.MaximumCarryForwardDays}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="col-md-2">
                        <label htmlFor="evidence" className="form-label">
                          Is Accrual
                        </label>
                        <div>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="IsAccrual"
                            id="flexSwitchCheckChecked"
                            checked={formData.IsAccrual === 1}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">
                          Accumulation / Month
                        </label>
                        <input
                          type="text"
                          class="form-control text-end"
                          placeholder="In Days"
                          id="AccumulationPerMonth"
                          aria-describedby="AccumulationPerMonth"
                          name="AccumulationPerMonth"
                          value={formData.AccumulationPerMonth}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Limit / Year</label>
                        <input
                          type="text"
                          class="form-control text-end"
                          placeholder="In Days"
                          id="LimitPerYear"
                          aria-describedby="LimitPerYear"
                          name="LimitPerYear"
                          value={formData.LimitPerYear}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>

                {/* item 4 */}
                <Accordion.Item eventKey="3">
                  <Accordion.Header className="">
                    <div className="flex-grow-1 text-dark fw-bold">
                      Add New Record
                    </div>
                    <span className="me-2 accordion_icon">
                      <FontAwesomeIcon
                        icon={activeKey === "3" ? faMinus : faPlus}
                      />
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <table id="poctable_head" className="table table-bordered">
                      <thead className="text-center">
                        <tr>
                          <th>Leave Accrual Type</th>
                          <th>Min No. of Yrs</th>
                          <th>Max No. of Yrs</th>
                          <th>No. of Allow Leaves</th>
                          <th>From Date</th>
                          <th>To Date</th>
                          <th>Delete</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {formData.lines.map((line, index) => (
                          <tr key={line.LineNo}>
                            <td>
                              <input
                                type="text"
                                name="GroupCategoryLabel"
                                className="form-control"
                                value={line.GroupCategoryLabel}
                                onChange={(e) => handleChange(e, index)}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                name="MinimumNo"
                                className="form-control"
                                value={line.MinimumNo}
                                onChange={(e) => handleChange(e, index)}
                              />
                            </td>
                            <td>
                              <input
                                name="MaximumNo"
                                className="form-control"
                                value={line.MaximumNo}
                                onChange={(e) => handleChange(e, index)}
                              />
                            </td>
                            <td>
                              <input
                                name="AllowLeaveNo"
                                className="form-control"
                                value={line.AllowLeaveNo}
                                onChange={(e) => handleChange(e, index)}
                              />
                            </td>
                            <td>
                              <ReactDatePicker
                                showYearDropdown
                                showPopperArrow
                                className="form-control"
                                placeholderText="From Date"
                                dateFormat="dd-MM-yyyy"
                                selected={
                                  line.FromDate
                                    ? moment(
                                      line.FromDate

                                    ).format("DD-MMM-YYYY")
                                    : null
                                }
                                onChange={(date) =>
                                  handleDateChange(date, index, "FromDate")
                                }
                              />
                            </td>
                            <td>
                              <ReactDatePicker
                                showYearDropdown
                                showPopperArrow
                                className="form-control"
                                placeholderText="To Date"
                                dateFormat="dd-MM-yyyy"
                                selected={
                                  line.ToDate
                                    ? moment(line.ToDate).format("DD-MMM-YYYY")
                                    : null
                                }
                                onChange={(date) =>
                                  handleDateChange(date, index, "ToDate")
                                }
                              />
                            </td>
                            <td>
                              <div
                                type="button"
                                onClick={() => handleDeleteLine(index)}
                              >
                                <i className="icons bi bi-trash"></i>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <button
                      type="button"
                      className="custom-btn mt-1 mb-2"
                      onClick={handleAddLine}
                    >
                      <i className="fa fa-plus"></i>Add
                    </button>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <div className="row mt-2">
                <div className="text-end">
                  {/* <Link to="/" className="btn-info me-2">
                  Cancel
                </Link> */}
                  <button
                    type="button"
                    onClick={() => navigate("/leave-list")}
                    className="cancel-btn me-2"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={submitted ? true : false}
                    onClick={handleEdit}
                    className="custom-btn"
                  >
                    {submitted ? <FaSpinner class="sm-spinner" /> : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditLeaveForm;
